module.exports = __webpack_public_path__ + "static/img/Mediakit@2x.f50e6fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/misc/2x/Mediakit@2x.png
// module id = yBht
// module chunks = 1